import * as Types from './@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddGoGoLiveParentGuideLocaleMutationVariables = Types.Exact<{
  goGoLiveParentGuideId: Types.Scalars['Int']['input'];
  market: Types.Scalars['String']['input'];
  introduction?: Types.InputMaybe<Types.Scalars['String']['input']>;
  learningGoals?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  showAndTell?: Types.InputMaybe<Types.Scalars['String']['input']>;
  user: Types.Scalars['String']['input'];
}>;


export type AddGoGoLiveParentGuideLocaleMutation = { __typename?: 'Mutation', addGoGoLiveParentGuideLocale: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const AddGoGoLiveParentGuideLocaleDocument = gql`
    mutation AddGoGoLiveParentGuideLocale($goGoLiveParentGuideId: Int!, $market: String!, $introduction: String, $learningGoals: [String!], $showAndTell: String, $user: String!) {
  addGoGoLiveParentGuideLocale(
    request: {goGoLiveParentGuideId: $goGoLiveParentGuideId, market: $market, introduction: $introduction, learningGoals: $learningGoals, showAndTell: $showAndTell, user: $user}
  ) {
    count
    error
  }
}
    `;
export type AddGoGoLiveParentGuideLocaleMutationFn = Apollo.MutationFunction<AddGoGoLiveParentGuideLocaleMutation, AddGoGoLiveParentGuideLocaleMutationVariables>;

/**
 * __useAddGoGoLiveParentGuideLocaleMutation__
 *
 * To run a mutation, you first call `useAddGoGoLiveParentGuideLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGoGoLiveParentGuideLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGoGoLiveParentGuideLocaleMutation, { data, loading, error }] = useAddGoGoLiveParentGuideLocaleMutation({
 *   variables: {
 *      goGoLiveParentGuideId: // value for 'goGoLiveParentGuideId'
 *      market: // value for 'market'
 *      introduction: // value for 'introduction'
 *      learningGoals: // value for 'learningGoals'
 *      showAndTell: // value for 'showAndTell'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useAddGoGoLiveParentGuideLocaleMutation(baseOptions?: Apollo.MutationHookOptions<AddGoGoLiveParentGuideLocaleMutation, AddGoGoLiveParentGuideLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGoGoLiveParentGuideLocaleMutation, AddGoGoLiveParentGuideLocaleMutationVariables>(AddGoGoLiveParentGuideLocaleDocument, options);
      }
export type AddGoGoLiveParentGuideLocaleMutationHookResult = ReturnType<typeof useAddGoGoLiveParentGuideLocaleMutation>;
export type AddGoGoLiveParentGuideLocaleMutationResult = Apollo.MutationResult<AddGoGoLiveParentGuideLocaleMutation>;
export type AddGoGoLiveParentGuideLocaleMutationOptions = Apollo.BaseMutationOptions<AddGoGoLiveParentGuideLocaleMutation, AddGoGoLiveParentGuideLocaleMutationVariables>;